export function readMacro(val) {
  // Remove whitespace and lower
  let valStrip = val.toLowerCase().replace(/\s+/g, "");
  
  let dice_roll = null;
  let message = null;
  let multi = 1;
  let dice = [];
  let modifier = 0;
  let num = 0;
  let rolls = [];

  const diceRoll = (str) => {
    let diceCont = str.split("d");
    let diceType = parseInt(diceCont[1]);
    let numDice = 1; // Default to one dice as catch for empty string
    let multiplier = 1; // Default to adding dice 
    
    if ((diceCont[0]!=="")&&(diceCont[0]!=="-")){
      numDice = Math.abs(parseInt(diceCont[0])); // Find number of dice (absolute value)
    }

    if (diceCont[0].startsWith("-")){ // If negative modifier on dice include this
      multiplier = -1;
    } 
    
    for (let i = 0; i < numDice; i++) {
      num = parseInt(diceType * Math.random() + 1);
      dice_roll += multiplier*num;
      rolls.push(multiplier*num);
      dice.push(diceType); //Record dice type e.g., d20
    }

  };
  const getModifier = (str) => {
    modifier = parseInt(str)+modifier
  };

  try {
    // Check string starts with int d or #roll or /roll int if so apply dice logic
    const pcMask = /^[#/]{1}(roll|)[0-9]{0,10000}[d]{1}[0-9]{0,10000}/;
    if (pcMask.test(valStrip)) {
      let str = valStrip.split(/^[#/]{1}(roll|)/).pop();
      let diceContents = str.match(/[-]{0,1}[0-9]{0,10000}[d]{1}[0-9]{0,10000}/g)
      let modifiers = str.match(/[+-]{1}[0-9]{1,10000}(?![d])/g)
 
      diceContents.map( (i) => diceRoll(i))
      if(modifiers){
        modifiers.map( (i) => getModifier(i))
        dice_roll += parseInt(modifier);
      }
  
      message = "Success";
    }
  } catch {
    message = "Oops! Something wrong with your command: " + val;
  }
  return {
    macro: val,
    diceType: dice,
    diceRoll: dice_roll,
    dice: rolls,
    modifier: modifier,
    message: message,
    multiplier: multi,
  };
}
